import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../AuthProvider';
import { useNavigate } from 'react-router-dom';
import './mycss.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



import Apiconnect from "../services/Apiconnect.js";


const Login = () => {

   const { login } = useContext(AuthContext);
   const [bgimg, setBgimg] = useState('');
   const [email, setEmail] = useState('');
   const [password, setPassword] = useState('');
   const [passwordVisible, setPasswordVisible] = useState(false);
   const [isLoading, setIsLoading] = useState(false);



   const navigate = useNavigate();


   useEffect(() => {
      const randomImageUrl = getRandomImage();
      setBgimg(randomImageUrl);
   }, [setBgimg]);


   const togglePasswordVisibility = () => {
      setPasswordVisible(!passwordVisible);
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      setIsLoading(true);

      console.warn(email);
      console.warn(password);

      var indata = {
         "email": email,
         "password": password
      };

      console.warn(indata);




      Apiconnect.postDataNoauth("auth/login", indata).then((response) => {
         var resz = response.data;
         //console.log(resz);
         if (resz.status && resz.status === 1) {
            var zz_tok = resz.token;
            var zz_uusr = resz.user;
            console.log(zz_uusr);
            localStorage.setItem('token', zz_tok);
            const user_typ = zz_uusr.user_typ;
            const user_id = zz_uusr.user_id;
            localStorage.setItem('userId', user_id);
            localStorage.setItem('u_email', zz_uusr.email);
            localStorage.setItem('u_name', zz_uusr.name);
            localStorage.setItem('custId', zz_uusr.id);
            localStorage.setItem('user_typ', user_typ);

            // const custIdFromStorage = localStorage.getItem("custId");
            // console.log("Cust ID:", custIdFromStorage);
            

            login(1,user_typ);
            setEmail('');
            setPassword('');

            if (user_typ === 'Admin') {
               navigate('/admin/dashboard');
            } else if (user_typ === 'Customer') {
               navigate('/customer/dashboard');
            }
         } else {
            alert(response.data.message);
         }
         setIsLoading(false);
      }).catch((error) => {
         console.error(error);
         toast.error(error?.response.data.message || "Something went wrong!"); 
         setIsLoading(false);
      });
   };


   const getRandomImage = () => {
      const randomNum = Math.floor(Math.random() * 9) + 1; // Generates a number between 1 and 9
      // return `admin_codebase/bgpic${randomNum}.jpg`;
      return `admin_codebase/bgpic1.jpg`;
   };





   return (
      <>



         <div class="container-fluid p-0 vh-100"  >
            <div class="row g-0 vh-100">
               <div class="col-xl-7 example"
                  style={{

                     backgroundImage: `url(${bgimg})`,


                  }}

               >

               </div>

               <div class="col-xl-5 vh-100" >
                  <div class="auth-full-page-content p-md-5 p-4"  >
                     <div class="w-100 p-5" >

                        <div class="text-center">
                           <img style={{ maxWidth: '50%', marginBottom: 30, }} src="admin_codebase/b-logo.png" />
                           <h2><b>Login</b></h2>
                        </div>


                        <form onSubmit={handleSubmit} >
                           <div class="row">

                              <div class="col-md-12">
                                 <div class="mb-3">
                                    <label class="form-label" for="loginName">Email Address *</label>
                                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} class="form-control inp" placeholder="Enter Your Email" required />
                                 </div>
                              </div>
                           </div>

                           <div class="row">
                              <div class="col-md-12">
                                 <div class="mb-3">
                                    <label class="form-label" for="loginPassword">Password *</label>

                                    <div class="input-group">


                                       <input
                                          type={passwordVisible ? 'text' : 'password'}
                                          className="form-control inp"
                                          minLength="8"
                                          placeholder="Enter Your Password"
                                          value={password} onChange={(e) => setPassword(e.target.value)}
                                          required
                                       />
                                       <button type="button" className="btn btn-secondary" onClick={togglePasswordVisibility}>
                                          <i id="akhi" className={`fa ${passwordVisible ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                       </button>





                                    </div>
                                 </div>
                              </div>
                           </div>

                           <a href="/forgetpassword">Forgot password?</a>


                           <div class="form-outline mb-4">
                              <input
                                 type="submit"
                                 className="form-control form-control-lg btn btn-primary submit"
                                 value={isLoading ? "Please wait..." : "Login"}
                                 disabled={isLoading}
                              />
                           </div>
                        </form>

                        New Here? <a href="/register">Register</a>











                     </div>
                  </div>
               </div>
            </div>
         </div>
         <ToastContainer/>

      </>
   );
};

export default Login;
